import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/product-discovery-kit")({
  component: lazyRouteComponent(() => import("./-pages/admin.product-discovery-kit")),
  head: () => ({
    meta: [
      { title: "بلوك Discovery Kit في صفحة المنتج — إدارة" },
      {
        name: "description",
        content: "إظهار أو إخفاء بلوك طقم الاكتشاف في صفحات المنتج للموبايل والديسكتوب.",
      },
    ],
  }),
});
